import { formatMoney } from 'accounting'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useOrderBundle'

import type { OrderBundleModel } from '@models/types'

const OrderBundleListItem = (props: { orderBundle: OrderBundleModel }) => {
  const {
    orderBundle,
    orderBundle: {
      price,
      title,
    },
  } = props

  const { editOrderBundleUrl } = generateUrls(orderBundle)

  return (
    <DashboardModuleListItem
      href={editOrderBundleUrl}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {formatMoney(price)}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default OrderBundleListItem
